class MegaMenuTabs extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.mega-menu-tabs__tab').forEach((btn) => {
      btn.addEventListener('click', () => this.activate(btn.dataset.tabIndex));
    });
  }
  activate(index) {
    this.querySelectorAll('.mega-menu-tabs__tab').forEach((btn) => {
      var active = btn.dataset.tabIndex === index;
      btn.classList.toggle('mega-menu-tabs__tab--active', active);
      btn.setAttribute('aria-selected', active);
    });
    this.querySelectorAll('.mega-menu-tabs__panel').forEach((panel) => {
      var active = panel.dataset.tabPanel === index;
      panel.classList.toggle('mega-menu-tabs__panel--active', active);
      panel.hidden = !active;
    });
    this.querySelectorAll('.mega-menu-tabs__promo').forEach((promo) => {
      var active = promo.dataset.promoPanel === index;
      promo.classList.toggle('mega-menu-tabs__promo--active', active);
      promo.hidden = !active;
    });
  }
}
customElements.define('mega-menu-tabs', MegaMenuTabs);